import { render, staticRenderFns } from "./CurrencyPicker.vue?vue&type=template&id=4fd60f45&scoped=true&"
import script from "./CurrencyPicker.vue?vue&type=script&lang=js&"
export * from "./CurrencyPicker.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyPicker.vue?vue&type=style&index=0&id=4fd60f45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd60f45",
  null
  
)

export default component.exports